import { DimensionsHelper } from '@wix/native-pro-gallery-utils';
import { getCustomComponents } from '@wix/native-pro-gallery-info-elements';
import { GALLERY_CONSTS, optionsMap } from 'pro-gallery-lib';
export function calculateHeight(_ref) {
  let viewMode = _ref.viewMode,
    layoutHeight = _ref.layoutHeight,
    galleryOptions = _ref.galleryOptions,
    galleryContainer = _ref.galleryContainer,
    numOfItems = _ref.numOfItems,
    isInfinite = _ref.isInfinite,
    isFixedHorizontlaGalleryRatio = _ref.isFixedHorizontlaGalleryRatio,
    updatedHeight = _ref.updatedHeight,
    setHeightImp = _ref.setHeightImp;
  const tpaViewMode = {
    [GALLERY_CONSTS.viewMode.SITE]: 'site',
    [GALLERY_CONSTS.viewMode.EDIT]: 'editor',
    [GALLERY_CONSTS.viewMode.PREVIEW]: 'preview',
    [GALLERY_CONSTS.viewMode.SEO]: 'site'
  }[viewMode];
  DimensionsHelper.setWixHeight({
    height: layoutHeight,
    offsetTop: 0,
    styleParams: galleryOptions,
    container: galleryContainer,
    numOfItems,
    isInfinite,
    isFixedHorizontlaGalleryRatio,
    updatedHeight,
    setHeightImp,
    viewMode: tpaViewMode,
    clearHeight: undefined
  });
}
export function createCustomComponentAndPatchInfo(shouldUseNewInfo, props, options) {
  const shouldControlHorizontalAlignment = false;
  const shouldUseLineHeightFixer = true;
  const shouldInsertDefaults = true;
  options.EXPERIMENTALallowParallelInfos = true;
  const customComponents = getCustomComponents(shouldUseNewInfo, props, shouldControlHorizontalAlignment, shouldUseLineHeightFixer, shouldInsertDefaults, props.customInfoRenderer, props.customHoverRenderer, options);
  return customComponents;
}
export function calcContainer(isUnKnownContainer, containerData, isMobile) {
  return !isUnKnownContainer ? containerData : {
    width: isMobile ? 320 : 980,
    height: 800
  };
}
export function isInPrerenderMode(viewMode, isUnKnownContainer) {
  const isSEO = viewMode === GALLERY_CONSTS.viewMode.SEO;
  return isUnKnownContainer && !isSEO;
}
export function isUnknownContainer(container, options) {
  const _ref2 = container || {},
    width = _ref2.width,
    height = _ref2.height,
    isDefaultContainer = _ref2.isDefaultContainer;
  const scrollDirection = options[optionsMap.layoutParams.structure.scrollDirection];
  const isMissingWidth = typeof width !== 'number';
  const isMissingHeight = typeof height !== 'number';
  return isDefaultContainer || isMissingWidth || scrollDirection === GALLERY_CONSTS.layoutParams_structure_scrollDirection.HORIZONTAL && isMissingHeight;
}
export function wasCreatedByNewInfo(options) {
  // return options?.controllers?.experimental?.useNewInfo === 'true'
  const x = options.controllers_experimental_useNewInfo;
  return x === true || x === 'true' || x === 'yes';
}
//# sourceMappingURL=gallery.js.map